<template lang="html">
  <div class="tooltip">
    <span>?</span>
    <p class="tooltiptext" v-html="tooltipText"></p>
  </div>
</template>

<script lang="js">
export default {
  name: 'Tooltip',

  mounted() {

  },
  props: {
    tooltipText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {

    };
  },
  methods: {

  },
  computed: {

  },
};
</script>

<style scoped lang="scss">
  .tooltip {
    margin-left: 10px;
    position: relative;
    display: inline-block;
    vertical-align: middle;
    color: white;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: #B4C7E7;
    font-size: .6em;
    white-space: pre-line;

    span{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

    .tooltiptext {
      visibility: hidden;
      position: absolute;
      z-index: 11
      ;
      bottom: 140%;
      left: 50%;
      transform: translateX(-75%);
      width: 15vw;

      background-color: #B4C7E7;
      color: #758CB7;
      text-align: center;
      border-radius: 6px;
      padding: 5px;

      font-size: 1.4em;
      opacity: 0;
      transition: opacity 0.3s;

      &::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 75%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #B4C7E7 transparent transparent transparent;
      }
    }

    .tooltip:hover .tooltiptext {
      visibility: visible;
      opacity: 1;
    }
</style>
